import React, { useCallback, useMemo } from 'react';
import Accordion from 'components/Accordion';
import DatePicker from 'components/DatePicker';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import useForecastDate from 'hooks/Meteorology/Agro/CultureIndex/Location/useForecastDate';

export default function ForecastDate() {
  const { forecastDate, setForecastDate, availableDates } = useForecastDate();
  const closeAccordion = useMemo(
    () => buildAccordionClickFunction('culture-index-location-forecast-date'),
    [],
  );
  const setForecastDateAndClose = useCallback((date: Date | null) => {
    setForecastDate(date);
    closeAccordion();
  }, [setForecastDate, closeAccordion]);

  return (
    <Accordion.Item eventKey="forecast-date" id="culture-index-location-forecast-date">
      <Accordion.Header>Data de previsão</Accordion.Header>
      <Accordion.Body>
        <DatePicker
          inline
          selected={forecastDate}
          onChange={setForecastDateAndClose}
          includeDates={availableDates}
        />
      </Accordion.Body>
    </Accordion.Item>
  );
}
